/* @flow */

import * as React from 'react';
import { Routes, Route } from 'react-router-dom';

import useReduxState from 'src/shared/app/base/hook/useReduxState';
import { getRoutes } from 'src/shared/app/base/route/registry/routeRegistry';
import {
  getRouteHelp,
  getRoutesFromState,
} from 'src/shared/app/base/route/util/routeUtils';
import HelpButton from 'src/shared/app/help/component/HelpButton';

const HelpSwitch = (): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const state = useReduxState();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <Routes>
      {getRoutes()
        .filter((route) => getRouteHelp(route, state))
        .map((route) => {
          const [path] = getRoutesFromState(state, route);

          return (
            <Route
              path={path}
              element={<HelpButton />}
              // Use the same key to prevent re-renders when routes share the
              // same main component
              key={1}
            />
          );
        })}
    </Routes>
  );
};

export default React.memo<{}>(HelpSwitch);
